module.exports = __webpack_public_path__ + "img/fred.b4520c1.png";